import styled from "@emotion/styled";
import * as Mui from "@mui/material";
import { Tooltip } from "@mui/material";
import {
  ColDef,
  ICellRendererParams,
  SideBarDef,
  RowNode, GridReadyEvent, ColumnVisibleEvent, ColumnMovedEvent,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import { customTheme } from "../../../../config/theme/MuiTheme";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { useAgGridCustomDatasource } from "../../hooks/useAgGridCustomDatasource";
import { AutoCompleteOption } from "../common/AutoComplete";
// import AutoComplete from "../common/AutoComplete";
import AddIcon from "@mui/icons-material/Add";
import DescriptionIcon from "@mui/icons-material/Description";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SendIcon from "@mui/icons-material/Send";
import dayjs from "dayjs";
import FileSaver from "file-saver";
import React from "react";
import { useForm } from "react-hook-form";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import useToggle from "../../hooks/useToggle";
import EmptyStateGrid from "../common/EmptyStateGrid";
import FormInput from "../common/FormInput";
import GenericFilterBox from "../common/GenericFilterBox";
import { nameof } from "../common/ObjectUtils";
import { DamageFormTypes } from "./Types";
import Dialogs from "./dialogs";
// import { getAllRepository } from "../damagePriceList/ManipulateValues";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CommuteIcon from "@mui/icons-material/Commute";
import AgGridOperationTable from "../common/AgGridOperationTable";

import {
  Button,
  Chip,
  FormGroup
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useHasScope } from "../../../../config/globalConfig";
import SectionHeader from "../../../../util/component/SectionHeader";
import { saveFileFromResponse } from "../../utils";
import { ContextDamageForm } from "./DamageFormContext";
import { getAllMS, getAllRepository, getAllEvent, getAllEventType } from "./ManipulateValues";
import SendBilling from "./SendBIllings";
import DamageFormService from "./service/DamageFormService";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider"
import {EXPIRED_DEFAULT_COL_DEF} from "../../config";
import { useTranslation } from "react-i18next";


const StyledActionsBox = styled(Mui.Box)({
  backgroundColor: customTheme.palette.neutral.bright,
});

export const DamageFormTable = (props: any) => {
  const hasScope = useHasScope;
  const gridEquipmentsRef = useRef<AgGridReact>(null);
  const t = useOperationTranslation();
  const { i18n } = useTranslation();
  const [showCreate, toggleCreate] = useToggle();
  const [sendBilling, toggleSend] = useToggle();
  const { setLoading } = useContext(ContextOperation);
  const { tenant } = useContext(ContextOperation);
  const [listRepository, setListRepository] = useState<AutoCompleteOption[]>(
    []
  );
  const [listEvent, setListEvent] = useState<AutoCompleteOption[]>(
    []
  );
  const [listEventType, setListEventType] = useState<AutoCompleteOption[]>(
    []
  );
  const [listMS, setListMS] = useState<AutoCompleteOption[]>([]);
  const [checked, setChecked] = React.useState(true);
  const [disableBillButton, setDisabledBillButton] = React.useState(false);
  const [disableBillButtonCheck, setDisabledBillButtonCheck] =
    React.useState(false);
  const [queryParams] = useSearchParams();

  const [openDownloadModal, setOpenDownloadModal] = useToggle();
  const [openDownloadModalAccidentsFromLeasys, setOpenDownloadModalAccidentsFromLeasys] = useToggle();

  const [repositoryResponse, setRepositoryResponse] = useState<any>();
  const [eventResponse, setEventResponse] = useState<any>();
  const [eventTypeResponse, setEventTypeResponse] = useState<any>();

  //const [damageFormIds,setDamageFormIds] = React.useState<any>([]);
  //  let damageFormIds :any;
  const navigate = useNavigate();
  const snackbar = useSnackbar();

  const form = useForm<DamageFormTypes.FilterDamageForm>({
    defaultValues: {
      open: true,
      raDateFrom: null,
      raDateTo: null,
      createDateFrom: null,
      createDateTo: null,
      customerId: queryParams.get("customerId") || undefined,
	  eventTypeIds: [],
      repositoryIds: []
    },
  });

  const [showResult, toggleShowResult] = useToggle();

  const [leasysResult, setLeasysResult] = useState<any>([]);

  const damageFormContext = useContext(ContextDamageForm);

  const {globalData} = useContext(GlobalContext);

  const [damagePriceListDataSource, totalDamageForm, updateDatasourceDanger] =
    useAgGridCustomDatasource(
      DamageFormService.list.getDamageForm,
      [tenant, form.getValues()],
      [tenant, form.formState.submitCount]
    );

  const onCloseCreateDamageForm = () => {
    toggleCreate();
    updateDatasourceDanger();
  };

  useEffect(() => {
    gridEquipmentsRef.current?.api.deselectAll();
  }, [form.formState.submitCount]);

  const onSubmit = (data: any) => {
    data.repositoryId == 16
      ? setDisabledBillButton(true)
      : setDisabledBillButton(false);
  };

  const onReset = () => {
    form.reset();
    form.setValue("open", true);
    setChecked(true);
  };

  const toggleChecked = () => {
    form.setValue("open", !checked);
    setChecked((prev) => !prev);
  };

  useEffect(() => {
    form.reset();
    getAllRepository(tenant).then((response: any) =>
      setRepositoryResponse(response)
    );
    getAllEvent(tenant, 'true').then((response: any) =>
      setEventResponse(response)
    );
    getAllEventType(tenant).then((response: any) =>
      setEventTypeResponse(response)
    );
       //getAllMS(tenant).then((response: any) => setListMS(response));


  const msListOptions : AutoCompleteOption[] = [];

  if(globalData?.user?.mobilityStores) {
    for (var i = 0; i < globalData?.user?.mobilityStores.length; i++) {

        if (globalData?.user?.mobilityStores[i].id != 0 && tenant === globalData?.user?.mobilityStores[i].tenant) {

            msListOptions.push(
                {
                    label: globalData?.user?.mobilityStores[i].name,
                    value: globalData?.user?.mobilityStores[i].sapId
                }
            )
        }
    }
  }

  setListMS(msListOptions.sort((a,b) => a.label > b.label ? 1 : -1));

  }, [tenant]);

  useEffect(() => {
    if (!repositoryResponse) return;

    setListRepository(repositoryResponse.map((rep:any) => {
      return {
        value: rep.id,
        label: t(`masterDataDamage.repository.${rep.code.replaceAll('.', '_').toLowerCase()}` as any, rep.descr),
      };
    }))
  }, [i18n.language, repositoryResponse])

  useEffect(() => {
    if (!eventResponse) return;

    setListEvent(eventResponse.map((rep:any) => {
      return {
        value: rep.id,
        label: t(`masterDataDamage.event.${rep.code.replaceAll('.', '_').toLowerCase()}` as any, rep.descr),
      };
    }))
  }, [i18n.language, eventResponse])

  useEffect(() => {
    if (!eventTypeResponse) return;

    setListEventType(eventTypeResponse.map((rep:any) => {
      return {
        value: rep.id,
        label: t(`masterDataDamage.eventType.${rep.code.replaceAll('.', '_').toLowerCase()}` as any, rep.descr),
      };
    }))
  }, [i18n.language, eventTypeResponse])

  const handleDownloadExcel = () => {
    setLoading(true);
    DamageFormService.list
      .getExport(tenant, form.getValues())
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const filename =
            response.headers["content-disposition"].split("filename=")[1];
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          FileSaver.saveAs(blob, filename);
        } else {
          setOpenDownloadModal();
        }

      })
      .catch((error: any) => {
        setLoading(false);
        if (error?.response?.status === 406) {
          snackbar.show("error", t("damageForm.message.downloadExcelMaxRowsExceeded")); 
        } else {
          snackbar.show("error", t("damageForm.message.downloadErrorMessage"));
        }
      });
  };

  const onImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      const formData = new FormData();
      formData.append("file", img);
      if (img) {
        setLoading(true);
        DamageFormService.list.put
          .getExportLeasysrent(tenant, formData)
          .then((response: any) => {
            setLoading(false);
            if (response.status === 200) {
              const filename = response.headers["content-disposition"].split("filename=")[1];
              var blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              FileSaver.saveAs(blob, filename);
        
              updateDatasourceDanger();
              snackbar.show("success", t("damageForm.message.uploadClaimsOKMessage"));
            } else {
              setOpenDownloadModalAccidentsFromLeasys();
            }

          })
          .catch((error: any) => {
            setLoading(false);
            if (error?.response?.status === 406) {
              snackbar.show("error", t("damageForm.message.uploadExcelMaxRowsExceeded")); 
            } else {
              snackbar.show("error", t("damageForm.message.uploadErrorMessage"));
            }
          });
      }
    }
  };

  const onDrivaliaChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      const formData = new FormData();
      formData.append("file", img);
      if (img) {
        setLoading(true);
        DamageFormService.list.put
          .getExportDrivalia(tenant, formData)
          .then((response: any) => {
            setLoading(false);
            snackbar.show("success", t("damageForm.message.successMessage"));
            saveFileFromResponse(response);
          })
          .catch((error: any) => {
            setLoading(false);
            snackbar.show("error", t("damageForm.message.uploadErrorMessage"));
          });
      }
    }
  };

  const setStatusStyle = (data: string) => {
    return data == "OPEN" ? (
      <Chip
        color="error"
        label={t("damageForm.fields.opens")}
        variant="filled"
      />
    ) : (
      <Chip
        color="success"
        label={t("damageForm.fields.closed")}
        variant="filled"
      />
    );
  };

  const setTaskStatusStyle = (data: boolean) => {
    return data == true ? (
      <Chip
        color="error"
        label={t("damageForm.fields.opens")}
        variant="filled"
      />
    ) : (
      <Chip
        color="success"
        label={t("damageForm.fields.closed")}
        variant="filled"
      />
    );
  };

  const setCheckboxStyle = (data: boolean) => {
    return data;
  };

  const onOpenDamageFormDetails = (id: number | undefined) => {
    if (!id) {
      snackbar.show("warning", "No damage form id found for this row!");
      return;
    }

    damageFormContext.setGeneralInfo(undefined);
    damageFormContext.setTask1(undefined);
    damageFormContext.setTask2(undefined);
    damageFormContext.setTask3(undefined);

    const baseUrl = window.location.pathname;
    const safeId = encodeURIComponent(id ?? '');
    window.open(`${baseUrl}/details/${safeId}?tenant=${encodeURIComponent(tenant)}`);

  };
  useMemo(() => {
    damageFormContext.damageFormIds?.length
      ? setDisabledBillButtonCheck(true)
      : setDisabledBillButtonCheck(false);
  }, [damageFormContext.damageFormIds]);

  const onSelectionchange = () => {
    damageFormContext.setDamageFormIds(
      gridEquipmentsRef.current?.api
        .getSelectedNodes()
        .map((elemet: any, index: any) => elemet.data.id)
    );
  };

  const sendBill = () => {
    toggleSend();
  };

  const defaultColDef = useMemo<ColDef>(() => EXPIRED_DEFAULT_COL_DEF, []);
  const dangerColumns: ColDef[] = useMemo(() => [
    {
      field: "",
      suppressColumnsToolPanel: true,
      maxWidth: 40,         
      showDisabledCheckboxes: false,
      checkboxSelection: (params: any) =>
        setCheckboxStyle(params.data.sendableToFinance),
    },

    {
      field: nameof<DamageFormTypes.DamageForm>("code"),
      headerName: t("damageForm.fields.code"),
      //flex: 0.9,
      minWidth: 150,
      sortable: true
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("plate"),
      headerName: t("damageForm.fields.plate"),
      //flex: 0.9,
      minWidth: 120,
	  sortable: true,
      cellRenderer: (
        props: ICellRendererParams<DamageFormTypes.DamageForm>
      ) => {
        return (
          <Tooltip title={<>{props.data?.plate}</>}>
            <span>{props.data?.plate}</span>
          </Tooltip>
        );
      },
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("repositoryLabel"),
      headerName: t("damageForm.fields.repository"),
      minWidth: 150,
	  sortable: true,
      //flex: 1,
      cellRenderer: (
        props: ICellRendererParams<DamageFormTypes.DamageForm>
      ) => {
        const fromResponse = repositoryResponse?.find((rep:any) => rep.descr === props.data?.repositoryLabel);
        const code = fromResponse?.code.replaceAll('.', '_').toLowerCase();
        if (!code) { return <></> }
        const label = t(`masterDataDamage.repository.${code}` as any);
        return (
          <Tooltip title={<>{label}</>}>
            <span>{label}</span>
          </Tooltip>
        );
      },
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("eventLabel"),
      headerName: t("damageForm.fields.event"),
      minWidth: 150,
	  sortable: true,
      //flex: 1.4,
      cellRenderer: (
        props: ICellRendererParams<DamageFormTypes.DamageForm>
      ) => {
        const fromResponse = eventResponse?.find((rep:any) => rep.descr === props.data?.eventLabel);
        const code = fromResponse?.code.replaceAll('.', '_').toLowerCase();
        if (!code) { return <></> }
        const label = t(`masterDataDamage.event.${code}` as any);
        return (
          <Tooltip title={<>{label}</>}>
            <span>{label}</span>
          </Tooltip>
        );
      },
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("eventType"),
      headerName: t("damageForm.fields.eventType"),
      minWidth: 200,
	  sortable: true,
      //flex: 1.1,
      cellRenderer: (
        props: ICellRendererParams<DamageFormTypes.DamageForm>
      ) => {
        const fromResponse = eventTypeResponse?.find((rep:any) => rep.descr === props.data?.eventType);
        const code = fromResponse?.code.replaceAll('.', '_').toLowerCase();
        if (!code) { return <></> }
        const label = t(`masterDataDamage.eventType.${code}` as any);
        return (
          <Tooltip title={<>{label}</>}>
            <span>{label}</span>
          </Tooltip>
        );
      },
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("creationDate"),
      headerName: t("damageForm.fields.creationDate"),
      minWidth: 190,
	  sortable: true,
      //flex: 1.1,
      cellRenderer: (params: any) => {
        return <>{dayjs(`${params.data.creationDate}`).format("DD/MM/YYYY")}</>;
      },
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("formManagementLms"),
      headerName: t("damageForm.fields.managementlms"),
      minWidth: 190,
	  sortable: true,
      //flex: 0.9,
      cellRenderer: (
        props: ICellRendererParams<DamageFormTypes.DamageForm>
      ) => {
        return (
          <Tooltip title={<>{props.data?.formManagementLms}</>}>
            <span>{props.data?.formManagementLms}</span>
          </Tooltip>
        );
      },
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("status"),
      headerName: t("damageForm.fields.status"),
      minWidth: 120,
	  sortable: true,
      //flex: 0.8,
      cellRenderer: (params: any) => setStatusStyle(params.data.status),
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("openTaskOne"),
      headerName: t("damageForm.fields.task1"),
      minWidth: 250,
	  sortable: true,
      //flex: 0.9,
      cellRenderer: (params: any) =>
        setTaskStatusStyle(params.data.openTaskOne),
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("openTaskTwo"),
      headerName: t("damageForm.fields.task2"),
      minWidth: 250,
	  sortable: true,
      //flex: 0.9,
      cellRenderer: (params: any) =>
        setTaskStatusStyle(params.data.openTaskTwo),
    },
    {
      field: nameof<DamageFormTypes.DamageForm>("openTaskThree"),
      headerName: t("damageForm.fields.task3"),
      minWidth: 290,
	  sortable: true,
      //flex: 0.9,
      cellRenderer: (params: any) =>
        setTaskStatusStyle(params.data.openTaskThree),
    },
	{
      field: nameof<DamageFormTypes.DamageForm>("realInvoiceAmount"),
      headerName: t("damageForm.fields.realInvoiceAmount"),
      minWidth: 290,
      sortable: true,
      //flex: 0.9,
      cellRenderer: (params: any) =>
      {
        return (
          <Tooltip title={<>{params?.data?.realInvoiceAmount}</>}>
            <span>{params?.data?.realInvoiceAmount}</span>
          </Tooltip>
        );
      },

    },
    {
      field: nameof<DamageFormTypes.DamageForm>("realMissEquipInvoiceAmount"),
      headerName: t("damageForm.fields.realMissEquipInvoiceAmount"),
      minWidth: 290,
      sortable: true,
      //flex: 0.9,
      cellRenderer: (params: any) =>
      {
        return (
          <Tooltip title={<>{params?.data?.realMissEquipInvoiceAmount}</>}>
            <span>{params?.data?.realMissEquipInvoiceAmount}</span>
          </Tooltip>
        );
      },
    },
    {
      maxWidth: 50,
      suppressColumnsToolPanel: true,
      pinned: "right",
      cellStyle: {
        padding: "0px",
        border: "none",
      },
      cellRenderer: (
        props: ICellRendererParams<DamageFormTypes.DamageForm>
      ) => {
        return (
          <StyledActionsBox>
            <Mui.Tooltip title={t("tooltipTitle.damageForm")}>
              <Mui.IconButton
                color="accent"
                onClick={() => onOpenDamageFormDetails(props.data?.id)}
              >
                <DescriptionIcon />
              </Mui.IconButton>
            </Mui.Tooltip>
          </StyledActionsBox>
        );
      },
    },
  ], [tenant, i18n.language, repositoryResponse, eventResponse, eventTypeResponse]);

  const sideBar = useMemo<SideBarDef>(() => ({
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressColumnExpandAll: true,
        },
      },
    ],
    defaultToolPanel: '',
  }), []);

  const columnStateStorageKey = useMemo(() => {
    return `__OPERATION_PENDING.damageFormTableColumsConfig:${globalData.user.username}`;
  }, [globalData.user.username]);

  const onGridReady = useCallback((event: GridReadyEvent) => {
    const colState = JSON.parse(localStorage.getItem(columnStateStorageKey) || '[]');
    event.columnApi.applyColumnState({
      state: colState,
      applyOrder: true
    });

    event.api.sizeColumnsToFit();
  }, [columnStateStorageKey]);

  const onColumnVisible = useCallback((event: ColumnVisibleEvent) => {
    localStorage.setItem(columnStateStorageKey, JSON.stringify(event.columnApi.getColumnState()));
  }, [columnStateStorageKey]);

  const onColumnMoved = useCallback((event: ColumnMovedEvent) => {
    localStorage.setItem(columnStateStorageKey, JSON.stringify(event.columnApi.getColumnState()));
  }, [columnStateStorageKey]);

  return (
    <Mui.Box>
      <SectionHeader
        title={t("damageForm.titleFirst") + " " + t("damageForm.titleSecond")}
      />
      <>
        <form
          id="equipment-kit-tab-search-form"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <GenericFilterBox
            formId="equipment-kit-tab-search-form"
            onReset={() => {
              onReset();
            }}
          >
            <FormInput
              type="text"
              label={t("damageForm.fields.code")}
              name={nameof<DamageFormTypes.FilterDamageForm>("code")}
              formInstance={form}
              fullWidth
            />

            <FormInput
              type="text"
              label={t("damageForm.fields.plate")}
              name={nameof<DamageFormTypes.FilterDamageForm>("plate")}
              formInstance={form}
              fullWidth
            />
            <FormInput
              type="text"
              label={t("damageForm.fields.vin")}
              name={nameof<DamageFormTypes.FilterDamageForm>("vin")}
              formInstance={form}
              fullWidth
            />


<FormInput
              type="date"
              fullWidth
              name={nameof<DamageFormTypes.FilterDamageForm>("createDateFrom")}
              ampm={false}
              inputFormat={"DD/MM/YYYY HH:mm"}
              label={t("damageForm.fields.creationDateFrom")}
              value={form.watch("createDateFrom")}
              onChange={(newcreateDateFrom) => {
                form.setValue("createDateFrom", newcreateDateFrom);
              }}
            />

            <FormInput
              type="date"
              fullWidth
              name={nameof<DamageFormTypes.FilterDamageForm>("createDateTo")}
              ampm={false}
              inputFormat={"DD/MM/YYYY HH:mm"}
              label={t("damageForm.fields.creationDateTo")}
              value={form.watch("createDateTo")}
              onChange={(newcreateDateTo) => {
                form.setValue("createDateTo", newcreateDateTo);
              }}
            />

            <FormInput
              type="select"
              options={listEvent}
              label={t("damageForm.fields.event")}
              name={nameof<DamageFormTypes.FilterDamageForm>("eventId")}
              value={form.watch("eventId")}
              onChange={(value) => {
                form.setValue(
                  nameof<DamageFormTypes.FilterDamageForm>("eventId"),
                  value
                );
              }}
              fullWidth
            />

            <FormInput
              type="select"
              options={listEventType}
              label={t("damageForm.fields.eventType")}
              name={nameof<DamageFormTypes.FilterDamageForm>("eventTypeIds")}
			  multiple={true}
              value={form.watch("eventTypeIds")}
              onChange={(value) => {
                form.setValue(
                  nameof<DamageFormTypes.FilterDamageForm>("eventTypeIds"),
                  value
                );
              }}
              fullWidth
            />


            <FormInput
              type="select"
              options={listRepository}
              label={t("damageForm.fields.repository")}
              name={nameof<DamageFormTypes.FilterDamageForm>("repositoryIds")}
			  multiple={true}
              value={form.watch("repositoryIds")}
              onChange={(value) => {
                form.setValue(
                  nameof<DamageFormTypes.FilterDamageForm>("repositoryIds"),
                  value
                );
              }}
              fullWidth
            />

            <FormInput
              type="text"
              label={t("damageForm.fields.raNumber")}
              name={nameof<DamageFormTypes.FilterDamageForm>("raNumber")}
              formInstance={form}
              fullWidth
            />

            <FormInput
              type="date"
              fullWidth
              name={nameof<DamageFormTypes.FilterDamageForm>("raDateFrom")}
              ampm={false}
              inputFormat={"DD/MM/YYYY HH:mm"}
              label={t("damageForm.fields.raDateFrom")}
              value={form.watch("raDateFrom")}
              onChange={(newRaDateFrom) => {
                form.setValue("raDateFrom", newRaDateFrom);
              }}
            />

            <FormInput
              type="date"
              fullWidth
              name={nameof<DamageFormTypes.FilterDamageForm>("raDateTo")}
              ampm={false}
              inputFormat={"DD/MM/YYYY HH:mm"}
              label={t("damageForm.fields.raDateTo")}
              value={form.watch("raDateTo")}
              onChange={(newRaDateTo) => {
                form.setValue("raDateTo", newRaDateTo);
              }}
            />

            <FormInput
              type="select"
              options={listMS}
              label={t("damageForm.fields.managementlms")}
              name={nameof<DamageFormTypes.FilterDamageForm>(
                "formManagementLmsId"
              )}
              value={form.watch("formManagementLmsId")}
              onChange={(value) => {
                form.setValue(
                  nameof<DamageFormTypes.FilterDamageForm>(
                    "formManagementLmsId"
                  ),
                  value
                );
              }}
              fullWidth
            />
            <FormInput
              type="text"
              label={t("damageForm.fields.customerId")}
              name={nameof<DamageFormTypes.FilterDamageForm>("customerId")}
              formInstance={form}
              fullWidth
            />

            <FormInput
              type="text"
              label={t("damageForm.fields.customerSapId")}
              name={nameof<DamageFormTypes.FilterDamageForm>("customerSapId")}
              formInstance={form}
              fullWidth
            />


            <FormInput
              type="text"
              label={t("damageForm.fields.counterpartplate")}
              name={nameof<DamageFormTypes.FilterDamageForm>("counterpartPlate")}
              formInstance={form}
              fullWidth
            />


          </GenericFilterBox>


        </form>

        <Mui.Card>
          <Mui.CardContent>
            <Mui.Box
              sx={{
                backgroundColor: "white",
                border: " 1px solid #dbe4e9",
                borderRadius: "2px",
                padding: "9px 1px 3px 2px",
              }}
            >
              <Mui.Grid
                container
                spacing={1.5}
                alignItems="center"
                direction="row"
                justifyContent="flex-end"
              >
                {hasScope("SCOPE_UPDATE_DAMAGE_DAMAGE_FORM") && (
                  <>
                    <Mui.Grid item>
                      <label htmlFor="upload-photo">
                        <input
                          disabled={totalDamageForm ? false : true}
                          style={{ display: "none" }}
                          id="upload-photo"
                          onChange={onImageChange}
                          name="upload-photo"
                          type="file"
                        />
                        <Button
                          component="span"
                          variant="outlined"
                          disabled={totalDamageForm ? false : true}
                          color="accent"
                          startIcon={<CommuteIcon />}
                        >
                          <Mui.Typography variant="h6" color="inherit">
                            {t("damageForm.drivaliaAccidentButton")}
                          </Mui.Typography>
                        </Button>
                      </label>
                    </Mui.Grid>

                    <Mui.Grid item>
                      <label htmlFor="upload-photo1">
                        <input
                          disabled={totalDamageForm ? false : true}
                          style={{ display: "none" }}
                          id="upload-photo1"
                          onChange={onDrivaliaChange}
                          name="upload-photo1"
                          type="file"
                        />
                        <Button
                          component="span"
                          disabled={totalDamageForm ? false : true}
                          color="accent"
                          startIcon={<AttachMoneyIcon />}
                        >
                          <Mui.Typography variant="h6" color="inherit">
                            {t("damageForm.leasyButton")}
                          </Mui.Typography>
                        </Button>
                      </label>
                    </Mui.Grid>

                    <Mui.Grid item>
                      <Button
                        component="span"
                        color="accent"
                        onClick={() => sendBill()}
                        disabled={
                          disableBillButtonCheck && totalDamageForm
                            ? false
                            : true
                        }
                        startIcon={<SendIcon />}
                      >
                        <Mui.Typography variant="h6" color="inherit">
                          {t("damageForm.fotBillingButton")}
                        </Mui.Typography>
                      </Button>
                    </Mui.Grid>
                  </>
                )}
                <Mui.Grid item>
                  <FormGroup>
                    <Mui.FormControlLabel
                      name="open"
                      control={
                        <Mui.Switch
                          sx={{ margin: 1 }}
                          checked={checked}
                          name="open"
                          onChange={toggleChecked}
                          color="default"
                        />
                      }
                      label={t("damageForm.fields.open")}
                      // labelPlacement="end"
                    />
                  </FormGroup>
                </Mui.Grid>
                <Mui.Grid item>
                  <Mui.Button
                    variant="text"
                    size="icon"
                    disabled={totalDamageForm ? false : true}
                    onClick={handleDownloadExcel}
                    color="accent"
                  >
                    <Mui.Tooltip title={t("tooltipTitle.download")}>
                      <FileDownloadIcon />
                    </Mui.Tooltip>
                  </Mui.Button>
                </Mui.Grid>

                {hasScope("SCOPE_CREATE_DAMAGE_DAMAGE_FORM") && (
                  <Mui.Grid item>
                    <Mui.Button color="accent" variant="text" size="icon">
                      <Mui.Tooltip title={t("tooltipTitle.add")}>
                        <AddIcon
                        onClick={() =>navigate(`/operation/damages/forms/creation`)}
                        />
                      </Mui.Tooltip>
                    </Mui.Button>
                  </Mui.Grid>
                )}
              </Mui.Grid>
            </Mui.Box>

            <Mui.Grid>
              <Mui.Grid item sx={{ whiteSpace: "pre-wrap" }}>
                <Mui.Card>
				<AgGridOperationTable
                    gridRef={gridEquipmentsRef}
                    defaultColDef={defaultColDef}
                    columnDefs={dangerColumns}
                    onColumnVisible={onColumnVisible}
                    onColumnMoved={onColumnMoved}
                    onGridReady={onGridReady}
                    serverSideDatasource={damagePriceListDataSource}
                    rowModelType="serverSide"
                    rowSelection="multiple"
                    isRowSelectable={(params: RowNode<any>) => {
                      return params.data.sendableToFinance;}}
                    serverSideInfiniteScroll={true}
                    cacheBlockSize={50}
                    paginationPageSize={50}
                    onSelectionChanged={onSelectionchange}
                    rowStyle={{ width: "1000%" }}
                    suppressMultiSort
                    sideBar={sideBar}
                    emptyState={{
                      title: t("damageForm.pageTitles.noDangerTitle"),
                      content: t("damageForm.pageTitles.noDangerText"),
                    }}
                    totalElements={totalDamageForm}

                    />
                </Mui.Card>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.CardContent>
        </Mui.Card>
      </>

      <SendBilling
        open={sendBilling}
        onClose={toggleSend}
        updateDatasourceDamage={updateDatasourceDanger}
        //damageFormIds={damageFormIds}
        onSelectionchange={onSelectionchange}
      />
      <Dialogs.ShowLeasysResults
        open={showResult}
        onClose={toggleShowResult}
        taskName={t("damageForm.details.tabs.task3")}
        results={leasysResult}
      />
      <Dialogs.CreateDamageForm
        open={showCreate}
        onClose={onCloseCreateDamageForm}
      />
      {openDownloadModal && <Dialogs.ExportDamageForms
        setOpenDownloadModal={setOpenDownloadModal}
      />}
      {openDownloadModalAccidentsFromLeasys && <Dialogs.ExportAccidentsFromLeasys
        setOpenDownloadModal={setOpenDownloadModalAccidentsFromLeasys}
      />}
    </Mui.Box>
  );
};
